﻿//vue-select styling doesn't load properly by default
import './../Style/vue-select.scss';

//vue-select styling doesn't load properly by default
import './../Style/select2.scss';

//Push notifications are used globally
import './../Style/push-notifications.scss';